export default {"src":"/_next/static/media/Rectangle 4498.ada36372.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};